<nav id="left-navbar" class="left-navbar">
    <span class="after">
        <img [src]="employerBGUrl" class="bgEmployee">
    </span>
    <div class="toggle-menu" *ngIf="showMenu">
        <span class="line"></span>
    </div>
    <div class="header-logo">
        <img [src]="employerLogoUrl" (load)="load()" class="logo">
        <div class="name" style="font-size: 16px;color: #0571ba;">
            {{'Common.WelcomeMessage' | translate}} {{loggedInUser?.ProviderName}}
        </div>
        <!-- <div class="profile">
            <div class="profile-info">
                <div class="name">
                {{'Common.WelcomeMessage' | translate}} {{loggedInUser?.ProviderName}}
                </div>
            </div> 
        </div> -->
    </div>

    <div class="mobile-menu-container">
        <div class="mainmenu">
            <nav id="menu-main" [class.active]="isMainMenuSelected">
                <ul class="list-menu">
                    <li *ngFor="let item of mainMenuItems">
                        <a *ngIf="item?.IsCustomMenu==0" [routerLink]="item?.Link" routerLinkActive
                            #rla="routerLinkActive" class="{{item?.CssClass+' ' +(rla.isActive?'active':'')}}"
                            [ngClass]="isRouterActive(item.CssClass)">
                            <span>
                                <!--Batch for Benefit Notifications-->
                                <label *ngIf="item.Id==3 && this.loggedInUser.IsIndividual=='True'"
                                    style="right: 35px;position: absolute;" class="mainMenu-badge"></label>
                                <!-- <i [class.unreadnotification]="item.Id==5" *ngIf="(item.Id==5 && this.providerBadges.NotificationBadge>0)">{{providerBadges.NotificationBadge}}</i>  -->
                                <i [class.unreadnotification]="item.Id==5"
                                    *ngIf="(item.Id==5 && (this.loggedInUser.UnreadNotifications > 0 || this.loggedInUser.AcknowledgeNotificationsCount > 0))">{{notificationCount}}</i>
                            </span>
                            {{item?.Caption }}
                            <!-- {{'Menus.'+item?.CssClass | translate}} -->
                            <!-- {{providerBadges.NotificationBadge}} -->
                        </a>

                    </li>
                    <li *ngIf="moreMenuItems?.length>0"><a href="javascript:void(0);" class="more-menu"
                            (click)="moreMenus(true)"><span></span>{{'Menus.more'|translate}}</a></li>
                </ul>
            </nav>
            <nav id="menu-more" [class.active]="!isMainMenuSelected">
                <ul class="list-menu">
                    <li><a href="javascript:void(0);" (click)="moreMenus(false)"
                            class="back-to-menu">{{'Menus.backtomenu' | translate}}</a></li>
                    <li *ngFor="let item of moreMenuItems">
                        <a [routerLink]="item?.Link" title="{{'Menus.'+item?.CssClass | translate}}" routerLinkActive
                            #rla="routerLinkActive" class="{{item?.CssClass+' ' +(rla.isActive?'active':'')}}"
                            [ngClass]="isRouterActive(item?.CssClass)">
                            <span>
                            </span>
                            {{'Menus.'+item?.CssClass | translate}}</a>

                    </li>
                </ul>


            </nav>
        </div>
        <!-- Footer :: Starts-->
        <footer style="position: absolute !important">

            <div class="footermenu" style="z-index:9999;">
                <ul class="list-menu">
                    <li>
                        <a [routerLink]="['/settings']" routerLinkActive="active" class="settings">
                            <span></span>{{'Menus.settings'| translate}}</a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" (click)="logout()" class="logout">
                            <span></span>{{'Menus.logout'| translate}}</a>
                    </li>
                </ul>
            </div>
            <div class="bb-ad" *ngIf="showBBPromotionalImage=='True'">
                <a target="_blank" [routerLink]="['/upgrade']">
                    <img src="{{advertiseImage}}">
                </a>
            </div>

            <app-multi-lingual></app-multi-lingual>

        </footer>
        <!-- Footer :: Ends-->
    </div>


</nav>